import React, {} from 'react';
import './AddToHomeScreen.less';
import {DialogOverlay} from "../../dialog-layout/dialog-overlay/DialogOverlay";
import {Prompt} from "../../dialog-layout/prompt/Prompt";
import {AddToHomeScreenAndroid} from "../../compositions/add-to-home-screen-android/AddToHomeScreenAndroid";
import {AddToHomeScreenIos} from "../../compositions/add-to-home-screen-ios/AddToHomeScreenIos";
import Platform from '../../../platform';

export const ADD_TO_HOME_SCREEN_POPUP = 'ADD_TO_HOME_SCREEN_POPUP';

export const AddToHomeScreen = ({onOverlayClick, onDoneClick}) => {

	return <DialogOverlay onOverlayClick={onOverlayClick} isBottomContents>
		<Prompt isAndroid={Platform.isAndroid}>
			{
				Platform.isAndroid && <AddToHomeScreenAndroid onDoneClick={onDoneClick}/>
			}
			{
				Platform.isIOs && <AddToHomeScreenIos/>
			}
		</Prompt>
	</DialogOverlay>
}
